import React, { useCallback, useContext } from 'react';
import { MetaMaskContext } from '.';

import './WalletButtons.scss';
import './style.scss';

const ConnectButton = ({ className='', label='Connect with MetaMask' }) => {
  const { accounts, connect } = useContext(MetaMaskContext);

  const account = accounts[0] || '';
  const isConnnected = !!accounts.length;
  const accountLabel = account.slice(0,6) + '...' + account.slice(-4);
  const text = isConnnected ? accountLabel : label;

  const doConnect = useCallback(() => {
    const currentUrl = document.location.href.replace('http://', '').replace('https://', '');
    const returnUrl = `https://metamask.app.link/dapp/${currentUrl}?do-connect`;

    connect(returnUrl);
  }, [connect]);

  return (
    <div className={`col ${className} connect-button-container d-inline-flex`}>
      <div className="connect-options btn btn-sm">
        <a className="option option-metamask" onClick={doConnect}>
          <div className="image"> </div>
          <div className="info"> { text } </div>
        </a>
      </div>
    </div>
  );
};


export default ConnectButton;
